import React, { useState, useEffect } from 'react';
import {
  Calendar,
  List,
  ChevronsLeft,
  ChevronsRight,
  User,
  MessageSquareWarning,
} from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { NavLink } from './NavLink';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { useAuth } from '../../context/AuthContext';
import { ProfilePopup } from './ProfilePopup';
import { AccountSwitcher } from './AccountSwitcher';
import { BugReportModal } from '../BugReport/BugReportModal';

export const Sidebar = () => {
  const { t } = useTranslation();

  const [isExpanded, setIsExpanded] = useState(() => {
    const saved = localStorage.getItem('sidebarExpanded');
    return saved ? JSON.parse(saved) : false;
  });
  const { user } = useAuth();
  const [isProfileOpen, setIsProfileOpen] = useState(false);
  const [isBugReportOpen, setIsBugReportOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem('sidebarExpanded', JSON.stringify(isExpanded));
  }, [isExpanded]);

  const handleBugReport = () => {
    setIsBugReportOpen(true);
  };

  return (
    <aside
      className={`fixed left-0 top-0 h-screen bg-[#0055FF] border-r border-[#0044CC] z-20 flex flex-col ${
        isExpanded ? 'w-64' : 'w-16'
      }`}
    >
      {/* Logo and Title */}
      <div className="h-14 flex items-center border-b border-[#0044CC]">
        <div className="w-16 flex justify-center">
          <img src="/assets/images/side-bar-logo.png" alt="Sol Media Logo" className="h-4 w-auto" />
        </div>
        {isExpanded && (
          <span className="ml-3 text-base font-semibold text-white whitespace-nowrap">
            SOL MEDIA CRM
          </span>
        )}
      </div>

      <AccountSwitcher isExpanded={isExpanded} />

      {/* Navigation Links */}
      <nav className="flex-1 py-4 text-white flex flex-col">
        {/* Top Navigation Items */}
        <NavLink
          to="/"
          icon={List}
          label={t('navigation.meetings')}
          isExpanded={isExpanded}
        />
        <NavLink
          to="/calendar"
          icon={Calendar}
          label={t('navigation.calendar')}
          isExpanded={isExpanded}
        />

        {/* Bottom Section */}
        <div className="mt-auto">
          {/* Bug Report Button */}
          <NavLink
            icon={MessageSquareWarning}
            label={t('navigation.reportBug')}
            isExpanded={isExpanded}
            onClick={handleBugReport}
          />
          <NavLink
            icon={User}
            label={t('navigation.profile')}
            isExpanded={isExpanded}
            onClick={() => setIsProfileOpen(true)}
          />
          {/* Expand/Collapse Button */}
          <div className="h-14 flex items-center">
            <div className={`${isExpanded ? 'w-full px-4 flex justify-end' : 'w-16 flex justify-center'}`}>
              <button
                onClick={() => setIsExpanded(!isExpanded)}
                className="p-2 text-white hover:bg-[#0044CC]"
              >
                {isExpanded ? <ChevronsLeft className="w-6 h-6" /> : <ChevronsRight className="w-6 h-6" />}
              </button>
            </div>
          </div>
        </div>
      </nav>
      
      <ProfilePopup
        isOpen={isProfileOpen}
        onClose={() => setIsProfileOpen(false)}
      />
      <BugReportModal
        isOpen={isBugReportOpen}
        onClose={() => setIsBugReportOpen(false)}
      />
    </aside>
  );
};
